import { useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { internalChannel, internalVacancies, lateralMenuTextTranslate, successionPlanTranslate } from '../../../../i18n/translatedMessages'

import './menuPlan.sass'
import {
	AssessmentCenterIcon,
	CareerPlanIcon,
	ClimeCultureIcon,
	DocumentsIcon,
	ExitPlanIcon,
	InternalComunicationIcon,
	InternalJobsIcon,
	MyCompanyIcon,
	OmbusdmanIcon,
	OnboardingIcon,
	PeopleAnalitycsIcon,
	PerformanceIcon,
	SalaryIcon,
	SuccessionPlanIcon,
	SupportMyDNAIcon,
	TrainingsIcon,
	NominaIcon,
} from './MenuIcons'

const MenuPlan = ({ handleMenu, option }) => {
	const company = JSON.parse(localStorage.getItem('user')).name

	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	return (
		<div className='menu-plan  pe-4'>
			<ul>
				<NavLink to='/app/services/edit-industry'>
					<li onClick={handleMenu} data-option='1' className={option === '1' ? 'active-menu-plan' : ''}>
						<div className='tw-px-4'>
							<MyCompanyIcon />
						</div>
						<span>{lateralMenuTextTranslate.myBusiness}</span>
					</li>
				</NavLink>

				<li onClick={handleMenu} data-option='2' className={option === '2' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/list' className='tw-flex'>
						<div className='tw-px-4'>
							<PeopleAnalitycsIcon />
						</div>
						<span>{lateralMenuTextTranslate.peopleAnalytics}</span>
					</NavLink>
				</li>
				{option === '2' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='2' to='/app/services/list'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.myCollaborators}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='2' to='/app/services/new'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.collaboratorsRegister}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='2' to='/app/services/multiple-add'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.massiveRegister}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='2' to='/app/services/campaign'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.campaignMenu}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='15' className={option === '15' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/admission-documents' className='tw-flex'>
						<div className='tw-px-4'>
							<DocumentsIcon />
						</div>
						<span>Documentos</span>
					</NavLink>
				</li>
				{option === '15' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='15' to='/app/services/document-management'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Gestão de Documentos' : 'Gestión de Documentos'}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='15' to='/app/services/admission-documents'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Solicitar Documentos' : 'Solicitud documentos'}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='15' to='/app/services/employee-documents'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Documentos Recebidos' : 'Documentos Recibidos'}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='15' to='/app/services/knowledge-management'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Gestão de Conhecimento' : 'Gestión de Conocimientos'}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='15' to='/app/services/knowledge-ranking'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Ranking de Conhecimento' : 'Ranking de Conocimientos'}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='24' className={option === '24' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/nomina' className='tw-flex'>
						<div className='tw-px-4'>
							<NominaIcon />
						</div>
						<span>Nómina</span>
					</NavLink>
				</li>
				{option === '24' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='24' to='/app/services/nomina'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Reporteria' : 'Reporteria'}</div>
									</div>
								</NavLink>
								{/* <NavLink onClick={handleMenu} data-option='15' to='/app/services/employee-documents'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Processamento' : 'Processamiento'}</div>
									</div>
								</NavLink> */}
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='3' className={option === '3' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/badge-heores' className='tw-flex'>
						<div className='tw-px-4'>
							<OnboardingIcon />
						</div>
						<span>{lateralMenuTextTranslate.onBoarding}</span>
					</NavLink>
				</li>
				{option === '3' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='3' to='/app/services/badge-heores'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.knowBadgeHeroes}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='3' to='/app/services/onboarding'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Onboarding</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='4' className={option === '4' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/capacitaciones' className='tw-flex'>
						<div className='tw-px-4'>
							<TrainingsIcon />
						</div>
						<span>{lateralMenuTextTranslate.trainingAndDevelopment}</span>
					</NavLink>
				</li>
				{option === '4' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='4' to='/app/services/capacitaciones'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.manageTrainings}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='4' to='/app/services/development-guide'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.manageCompetences}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='4' to='/app/services/entrenamientos'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.workoutsMydna}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='4' to='/app/services/ebooks-y-contenidos'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.ebooksAndContent}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='4' to='/app/services/elearn-platforms'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Plataformas E-learning</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='5' className={option === '5' ? 'active-menu-plan' : ''}>
					<div className='tw-px-4'>
						<ClimeCultureIcon />
					</div>
					<span>{lateralMenuTextTranslate.climeAndCulture}</span>
				</li>
				{option === '5' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='5' to='/app/services/encuesta-clima'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.climeSurvey}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='5' to='/app/services/promoter-score'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.nps}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='5' to='/app/services/reporte-cultura'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.businessCulture}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='5' to='/app/services/match-cultura'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.matchCulture}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<NavLink onClick={handleMenu} data-option='6' to='/app/services/referencias'>
					<li onClick={handleMenu} data-option='6' className={option === '6' ? 'active-menu-plan' : ''}>
						<div className='tw-px-4'>
							<PerformanceIcon />
						</div>
						<span>{lateralMenuTextTranslate.performanceAnalysis}</span>
					</li>
				</NavLink>
				{option === '6' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/referencias'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.performancePotentialReferences}</div>
									</div>
								</NavLink>

								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-evaluation/performance'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.performanceMenuTitle}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-evaluation/potential'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.potentialMenuTitle}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-evaluation/nine-box'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.nineBoxMenuTitle}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-evaluation/competences'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>9box {lateralMenuTextTranslate.competenceAvaliation9Box}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-salary-evaluation/performance'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>9box Desempeño x Salarios</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-salary-evaluation/potential'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>9box Potencial x Salarios</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/evaluation/360'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.evaluation360}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/potential-files'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.historicEvaluations}</div>
									</div>
								</NavLink>
								{/* <NavLink  onClick={handleMenu} data-option='6' to='/app/services/employee-evaluation'>
								<div className='newmenu-item d-flex flex-row  p-1'>
									<div className='newmenu-link'>{lateralMenuTextTranslate.performance}</div>
								</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='6' to='/app/services/employee-evaluation'>
								<div className='newmenu-item d-flex flex-row  p-1'>
									<div className='newmenu-link'>{lateralMenuTextTranslate.potentialTitle}</div>
								</div>
								</NavLink> */}
							</div>
						</div>
					</>
				)}

				{!company.toUpperCase().includes('MAYEKAWA') && (
					<li onClick={handleMenu} data-option='7' className={option === '7' ? 'active-menu-plan' : ''}>
						<div className='tw-px-4'>
							<SalaryIcon />
						</div>
						<span>{lateralMenuTextTranslate.salariesAndBenefits}</span>
					</li>
				)}
				{option === '7' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/unit-report'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.unitReport}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/salarios'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.posicionesTitle}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/positions'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.salaryByPosiciones}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/bands'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.bands}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/dashboard'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Dashboard</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/salary/companies-by-industry'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Empresas por Industria</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/benefits'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.benefits}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='7' to='/app/services/emotional-salary'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.emotionalSalary}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='8' className={option === '8' ? 'active-menu-plan' : ''}>
					<div className='tw-px-4'>
						<AssessmentCenterIcon />
					</div>
					<span>{lateralMenuTextTranslate.professionalDevelopment}</span>
				</li>
				{option === '8' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='8' to='/app/services/assessment/competence'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.skillTest}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='8' to='/app/services/motivations-test'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.motivacionalTest}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='8' to='/app/services/english-test'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.englishLevelTest}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='9' className={option === '9' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/career/manager' className='tw-flex'>
						<div className='tw-px-4'>
							<CareerPlanIcon />
						</div>
						<span>{lateralMenuTextTranslate.careerPlan}</span>
					</NavLink>
				</li>
				{option === '9' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								{/* <NavLink onClick={handleMenu} data-option='9' to='/app/services/proyeccion-carrera'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.careerPlan}</div>
									</div>
								</NavLink> */}
								<NavLink onClick={handleMenu} data-option='9' to='/app/services/career/manager'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Por Gestor/RRHH</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='9' to='/app/services/career/algorithm'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Por Algoritmo</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='9' to='/app/services/career/employee'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Por Colaborador</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='9' to='/app/services/descripcion-posiciones'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.jobDescriptor}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='17' className={option === '17' ? 'active-menu-plan' : ''}>
					<NavLink onClick={handleMenu} data-option='17' to='/app/services/career/succession-plan' className='tw-flex'>
						<div className='tw-px-4'>
							<SuccessionPlanIcon />
						</div>
						<span className='newmenu-link'>{successionPlanTranslate.successionPlanTitle}</span>
					</NavLink>
				</li>

				<li onClick={handleMenu} data-option='14' className={option === '14' ? 'active-menu-plan' : ''}>
					<NavLink onClick={handleMenu} data-option='14' to='/app/services/internal-vacancies' className='tw-flex'>
						<div className='tw-px-4'>
							<InternalJobsIcon />
						</div>
						<span>{internalVacancies.internalVacanciesTitle}</span>
					</NavLink>
				</li>
				{option === '14' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='14' to='/app/services/internal-vacancies'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{internalVacancies.internalVacanciesCreate}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='14' to='/app/services/internal-vacancies-list'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{internalVacancies.internalVacanciesActive}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='29' className={option === '29' ? 'active-menu-plan' : ''}>
					<div className='tw-px-4'>
						<InternalComunicationIcon />
					</div>
					<span>{internalChannel.internalChannelTitle}</span>
				</li>
				{option === '29' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='29' to='/app/services/celebrations'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{language === 'pt' ? 'Notificações de Celebração' : 'Notificaciones de Celebración'}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='29' to='/app/services/internal-channel'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{internalChannel.internalChannelTitle}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				{/** FEEDBACK */}
				<li onClick={handleMenu} data-option='16' className={option === '16' ? 'active-menu-plan' : ''}>
					<NavLink className={'text-center tw-flex'} to='/app/services/feedbacks/sender'>
						<div className='tw-px-4'>
							<InternalComunicationIcon />
						</div>
						<span>Feedbacks</span>
					</NavLink>
				</li>
				{option === '16' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='16' to='/app/services/feedbacks/sender'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Feedbacks Enviados</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='16' to='/app/services/feedbacks/receiver'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>Feedbacks Recebidos</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='12' className={option === '12' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/ombudsman' className='tw-flex'>
						<div className='tw-px-4'>
							<OmbusdmanIcon />
						</div>
						<span>{lateralMenuTextTranslate.ombudsman}</span>
					</NavLink>
				</li>
				{option === '12' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='12' to='/app/services/ombudsman'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.occurrences}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}
				<li onClick={handleMenu} data-option='11' className={option === '11' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/genes' className='tw-flex'>
						<div className='tw-px-4'>
							<ExitPlanIcon />
						</div>
						<span>{lateralMenuTextTranslate.outplacement}</span>
					</NavLink>
				</li>
				{option === '11' && (
					<>
						<div className='d-flex flex-column align-items-end'>
							<div className='newmenu-container mb-1'>
								<NavLink onClick={handleMenu} data-option='11' to='/app/services/genes'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.knowGenes}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='11' to='/app/services/outplacement'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.realocation}</div>
									</div>
								</NavLink>
								<NavLink onClick={handleMenu} data-option='11' to='/app/services/encuesta-de-salida'>
									<div className='newmenu-item d-flex flex-row  p-1'>
										<div className='newmenu-link'>{lateralMenuTextTranslate.leaveSearch}</div>
									</div>
								</NavLink>
							</div>
						</div>
					</>
				)}

				<li onClick={handleMenu} data-option='13' className={option === '13' ? 'active-menu-plan' : ''}>
					<NavLink to='/app/services/support' className='tw-flex'>
						<div className='tw-px-4'>
							<SupportMyDNAIcon />
						</div>
						<span>Suporte MyDNA</span>
					</NavLink>
				</li>
			</ul>
		</div>
	)
}
export default MenuPlan
